import useTitanApp from "../../../../../hooks/useTitanApp";
import { ReferralModal } from "../../../../PatientConsultation/components/ReferralModal";
import {
  setCurrentShowPatientReferralLetterModal,
  setReferralLetter,
} from "../../../../../dispatchers/patientDispatchers";

export default function ReferralLetters() {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState;
  const {
    showPatientReferralLetterModal,
    patientReferalLetter,
    referralLetter,
    chatBotReferralLetter,
  } = patientState;

  const handleClostRefDialog = () => {
    setCurrentShowPatientReferralLetterModal(false);
    setReferralLetter("");
  };

  return (
    <ReferralModal
      open={showPatientReferralLetterModal}
      onOpenChange={(value) => {
        if (!value) {
          handleClostRefDialog();
        }
      }}
      onClose={handleClostRefDialog}
      initialTitle={
        referralLetter?.title ||
        chatBotReferralLetter?.title ||
        patientReferalLetter?.title
      }
      initialSubject={
        referralLetter?.subject ||
        chatBotReferralLetter?.subject ||
        patientReferalLetter?.subject
      }
      initialContent={
        referralLetter?.content ||
        chatBotReferralLetter?.content ||
        patientReferalLetter?.content ||
        patientReferalLetter?.referalLetter?.content ||
        ""
      }
    />
  );
}
